import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import CheckboxGroup from '../../../exportacion_react_pdf/CheckboxGroup';
import QuestionResponse from '../../../exportacion_react_pdf/QuestionResponse';


// Define el documento
const ExportPaso1 = ({ formData, styles }) => (
    <>
    
        {/* Sección de Identificació del proyecto */}
        <View style={styles.section}>
            <Text style={styles.textareaLabel_1}>"El registro de datos personales en este formato, autoriza a la ARN para la recolección, almacenamiento y uso de los mismos. En cumplimiento a la Ley 1581/12 y el Decreto 1377/13 y las demás normas que modifiquen, adicionen o complementen. Conozca la política de tratamiento de los datos personales de la ARN a través del siguiente link: http://www.reintegracion.gov.co/es/atencion/Paginas/politicas.aspx”</Text>
            <Text style={styles.textareaLabel_1}>A continuación el asesor le realizará preguntas, para conocer el estado del proyecto productivo, verificar el estado de los activos o insumos con el apoyo económico entregado por la ARN durante la intervención anterior, determinar las necesidades de asistencia técnica e identificar los activos o insumos a entregar.</Text>

            <Text style={styles.title_1}>I. Información Inicial Visita</Text>
            <CheckboxGroup
                label='¿Indique la modalidad de la visita?'
                selectedValue={formData?.modalidad_visita ?? ''}
                options={["Presencial", "Remota"]}>
            </CheckboxGroup>

            <QuestionResponse
                label={'¿Lugar donde se lleva a cabo la visita?:'}
                value={formData?.lugar_visita ?? ''}>
            </QuestionResponse>

            <QuestionResponse
                label={'Latitud:'}
                value={formData?.latuser ?? ''}>
            </QuestionResponse>

            <QuestionResponse
                label={'Longitud:'}
                value={formData?.lnguser ?? ''}>
            </QuestionResponse>

        </View>
    </>
);

export default ExportPaso1;